
import { combineReducers } from "@reduxjs/toolkit";
import dialogReducer from "@slices/dialog.slice";
import authReducer from "@slices/auth.slice";
import configReducer from "@slices/config.slice";

import brokerReducer from "@slices/broker.slice";
import dashboardReducer from "@slices/dashboard.slice";
import userReducer from "@slices/users.slice";
import operatorReducer from "@slices/operators.slice";
import reportsReducer from "@slices/report.slice";
import reportsDetailsReducer from "@slices/report-details.slice";
import valueReducer from "@slices/value.slice"

// import dashboardReducer from "@slices/dashboard.slice";

const rootReducer = combineReducers({
  dialogs: dialogReducer,
  auth: authReducer,
  config: configReducer,
  broker: brokerReducer,
  usersList: userReducer,
    operatorsList: operatorReducer,
  dashboard: dashboardReducer,
  reports: reportsReducer,
    reportsDetails: reportsDetailsReducer,
  valueList: valueReducer,
  // dashboard: dashboardReducer,
});

export default rootReducer;
